import { render } from "./Program.vue?vue&type=template&id=0473272d"
import script from "./Program.vue?vue&type=script&lang=ts"
export * from "./Program.vue?vue&type=script&lang=ts"
script.render = render

export default script